(function () {
  var dataEl = document.getElementById('acl-qs-data');
  if (!dataEl) return;
  var DATA = {};
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var MONEY = dataEl.getAttribute('data-money') || '£{{amount}}';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var camp = document.querySelector('.acl[data-acl-campaign]');
  var CID = camp ? camp.getAttribute('data-acl-campaign') : '';
  function money(c) {
    var a = c / 100;
    var s = a % 1 === 0 ? String(a) : a.toFixed(2);
    return MONEY.replace(/{{[^}]*}}/, s);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function nice(s) { return String(s).toLowerCase().split(' ').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); }
  function isColour(n) { n = n.toLowerCase(); return n.indexOf('col') === 0; }
  var qs = document.createElement('div');
  qs.className = 'acl-qs';
  qs.setAttribute('aria-hidden', 'true');
  qs.innerHTML =
    '<div class="acl-qs__backdrop" data-qs-close></div>' +
    '<aside class="acl-qs__panel" role="dialog" aria-modal="true" aria-labelledby="acl-qs-title">' +
    '<header class="acl-qs__head"><div><p class="acl-qs__eyebrow">Quick shop</p><h2 class="acl-qs__title" id="acl-qs-title"></h2></div>' +
    '<button type="button" class="acl-qs__x" data-qs-close aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg></button></header>' +
    '<div class="acl-qs__body"></div>' +
    '<footer class="acl-qs__foot"><p class="acl-qs__err" role="alert"></p><button type="button" class="acl-qs__add" data-qs-add></button><p class="acl-qs__small">Not sure on your size? Tap Size guide.</p></footer>' +
    '</aside>';
  document.body.appendChild(qs);
  var body = qs.querySelector('.acl-qs__body');
  var titleEl = qs.querySelector('.acl-qs__title');
  var addBtn = qs.querySelector('[data-qs-add]');
  var errEl = qs.querySelector('.acl-qs__err');
  var lastFocus = null;
  var items = [];
  function variantFor(p, sel) {
    for (var i = 0; i < p.v.length; i++) {
      var v = p.v[i], ok = true;
      for (var k = 0; k < p.o.length; k++) { if (sel[k] != null && v[2][k] !== sel[k]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function anyAvailable(p, sel) {
    return p.v.some(function (v) {
      for (var k = 0; k < p.o.length; k++) { if (sel[k] != null && v[2][k] !== sel[k]) return false; }
      return v[1];
    });
  }
  function render(handles, title) {
    items = [];
    body.innerHTML = '';
    handles.forEach(function (h) {
      var p = DATA[h];
      if (!p) return;
      var it = { h: h, p: p, sel: [], on: true, el: null, vals: [] };
      p.o.forEach(function (name, k) {
        var vals = [];
        p.v.forEach(function (v) { if (vals.indexOf(v[2][k]) < 0) vals.push(v[2][k]); });
        it.vals[k] = vals;
        it.sel[k] = vals.length === 1 ? vals[0] : null;
      });
      var el = document.createElement('div');
      el.className = 'acl-qs__item';
      el.setAttribute('data-h', h);
      var colourIdx = -1;
      p.o.forEach(function (n, k) { if (isColour(n)) colourIdx = k; });
      var wash = colourIdx > -1 && it.vals[colourIdx].length === 1 ? nice(it.vals[colourIdx][0]) : '';
      var html =
        '<div class="acl-qs__top">' +
        (handles.length > 1 ? '<label class="acl-qs__check"><input type="checkbox" checked data-qs-on aria-label="Include this item"><span></span></label>' : '') +
        '<a class="acl-qs__img" href="' + esc(p.u) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy"></a>' +
        '<div class="acl-qs__info"><p class="acl-qs__name">' + esc(p.t) + '</p>' +
        (wash ? '<p class="acl-qs__wash">' + esc(wash) + '</p>' : '') +
        '<p class="acl-qs__price">' + money(p.v[0][3]) + '</p>' +
        '<a class="acl-qs__pdp" href="' + esc(p.u) + '">View full details</a></div></div>';
      var sizeDone = false;
      p.o.forEach(function (n, k) {
        if (it.vals[k].length < 2) return;
        var lname = n.toLowerCase();
        var label = lname === 'size' ? 'Size (UK)' : lname === 'length' ? 'Leg length' : n;
        html += '<div class="acl-qs__opt" data-k="' + k + '"><div class="acl-qs__lab"><span>' + esc(label) + '<em class="acl-qs__picked"></em></span>' +
          (!sizeDone && lname === 'size' ? '<button type="button" class="acl-qs__sg" data-qs-sg="' + esc(p.u) + '">Size guide</button>' : '') +
          '</div><div class="acl-qs__chips' + (it.vals[k].length <= 4 ? ' acl-qs__chips--seg' : '') + '">' +
          it.vals[k].map(function (val) { return '<button type="button" class="acl-qs__chip" data-val="' + esc(val) + '">' + esc(val) + '</button>'; }).join('') +
          '</div></div>';
        if (lname === 'size') sizeDone = true;
      });
      el.innerHTML = html;
      it.el = el;
      body.appendChild(el);
      items.push(it);
      el.addEventListener('click', function (e) {
        var chip = e.target.closest('.acl-qs__chip');
        if (chip && !chip.disabled) {
          var k = +chip.closest('.acl-qs__opt').getAttribute('data-k');
          var val = chip.getAttribute('data-val');
          it.sel[k] = it.sel[k] === val ? null : val;
          it.p.o.forEach(function (_, j) {
            if (j !== k && it.sel[j] != null && it.vals[j].length > 1 && !anyAvailable(it.p, it.sel)) it.sel[j] = null;
          });
          it.el.classList.remove('is-missing');
          errEl.textContent = '';
          refresh();
        }
      });
      var cb = el.querySelector('[data-qs-on]');
      if (cb) cb.addEventListener('change', function () { it.on = cb.checked; el.classList.toggle('is-off', !it.on); refresh(); });
    });
    titleEl.textContent = title || (items.length > 1 ? 'Shop the look' : (items[0] ? items[0].p.t : 'Quick shop'));
    errEl.textContent = '';
    refresh();
  }
  function refresh() {
    var total = 0, count = 0;
    items.forEach(function (it) {
      it.el.querySelectorAll('.acl-qs__opt').forEach(function (opt) {
        var k = +opt.getAttribute('data-k');
        opt.querySelector('.acl-qs__picked').textContent = it.sel[k] ? ': ' + it.sel[k] : '';
        opt.querySelectorAll('.acl-qs__chip').forEach(function (chip) {
          var val = chip.getAttribute('data-val');
          var test = it.sel.slice(); test[k] = val;
          var avail = anyAvailable(it.p, test);
          chip.disabled = !avail;
          chip.classList.toggle('is-on', it.sel[k] === val);
          chip.title = avail ? '' : 'Sold out';
        });
      });
      if (it.on) { count++; total += it.p.v[0][3]; }
    });
    var label = count > 1 ? 'Add ' + count + ' items to bag' : 'Add to bag';
    addBtn.innerHTML = '<span>' + label + '</span><span>' + money(total) + '</span>';
    addBtn.disabled = count === 0;
  }
  function open(handles, title, trigger) {
    lastFocus = trigger || document.activeElement;
    render(handles, title);
    qs.classList.add('is-open');
    qs.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('acl-qs-lock');
    setTimeout(function () { var x = qs.querySelector('.acl-qs__x'); if (x) x.focus(); }, 50);
  }
  function close() {
    qs.classList.remove('is-open');
    qs.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('acl-qs-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-acl-qs]');
    if (t) {
      var hs = t.getAttribute('data-acl-qs').split(',').map(function (s) { return s.trim(); }).filter(function (h) { return h && DATA[h]; });
      if (!hs.length) return;
      e.preventDefault();
      document.querySelectorAll('.acl-hs.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      open(hs, t.getAttribute('data-acl-qs-title'), t);
      return;
    }
    if (e.target.closest('[data-qs-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && qs.classList.contains('is-open') && !document.querySelector('#acl-sg-host #ssgx-toggle:checked')) close();
  });
  addBtn.addEventListener('click', function () {
    errEl.textContent = '';
    var lines = [], missing = null, added = [];
    items.forEach(function (it) {
      if (!it.on) return;
      var full = it.sel.every(function (s) { return s != null; });
      var v = full ? variantFor(it.p, it.sel) : null;
      if (!v || !v[1]) { it.el.classList.add('is-missing'); if (!missing) missing = it; return; }
      lines.push({ id: v[0], quantity: 1, properties: CID ? { _campaign: CID } : {} });
      added.push({ h: it.h, v: v[2].join(' / '), p: v[3] });
    });
    if (missing) {
      var need = missing.p.o.filter(function (n, k) { return missing.sel[k] == null; }).map(function (n) { n = n.toLowerCase(); return n === 'length' ? 'leg length' : n; });
      errEl.textContent = 'Choose your ' + (need.join(' and ') || 'options') + ' for the ' + missing.p.t + '.';
      missing.el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    if (!lines.length) return;
    addBtn.disabled = true;
    addBtn.classList.add('is-busy');
    var cd = document.querySelector('cart-drawer');
    var payload = { items: lines };
    var useDrawer = cd && typeof cd.renderContents === 'function' && typeof cd.getSectionsToRender === 'function';
    if (useDrawer) {
      payload.sections = cd.getSectionsToRender().map(function (s) { return s.section; });
      payload.sections_url = window.location.pathname;
    }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        addBtn.classList.remove('is-busy');
        addBtn.disabled = false;
        if (!res.ok) { errEl.textContent = res.j.description || res.j.message || 'Sorry, that could not be added. Please try again.'; document.dispatchEvent(new CustomEvent('acl:add_error', { detail: { message: errEl.textContent } })); return; }
        document.dispatchEvent(new CustomEvent('acl:added', { detail: { count: added.length, value: added.reduce(function (a, x) { return a + x.p; }, 0) / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP', handles: added.map(function (x) { return x.h; }).join(','), variants: added.map(function (x) { return x.h + ' ' + x.v; }).join(' | ') } }));
        close();
        if (useDrawer) {
          try { cd.renderContents(res.j); } catch (e) {}
          try { cd.open(); } catch (e) { window.location.href = root + 'cart'; }
        } else {
          window.location.href = root + 'cart';
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { addBtn.classList.remove('is-busy'); addBtn.disabled = false; errEl.textContent = 'Sorry, something went wrong. Please try again.'; });
  });
  var cache = {};
  var host = document.createElement('div');
  host.id = 'acl-sg-host';
  document.body.appendChild(host);
  function runScripts(scope) {
    scope.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }
  function showGuide(html) {
    host.innerHTML = html;
    runScripts(host);
    var tg = host.querySelector('#ssgx-toggle');
    if (!tg) return false;
    tg.checked = true;
    tg.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qs-sg]');
    if (!b) return;
    var url = b.getAttribute('data-qs-sg');
    if (cache[url]) { if (!showGuide(cache[url])) window.location.href = url; return; }
    b.classList.add('is-busy');
    fetch(url).then(function (r) { return r.text(); }).then(function (txt) {
      b.classList.remove('is-busy');
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var sg = doc.getElementById('ssgx-sg');
      var wrap = doc.querySelector('.amb-sgwrap') || (sg && sg.parentNode);
      if (!wrap) { window.location.href = url; return; }
      cache[url] = wrap.innerHTML;
      showGuide(cache[url]);
    }).catch(function () { b.classList.remove('is-busy'); window.location.href = url; });
  });
  document.querySelectorAll('.acl .acl-rail .acl-card').forEach(function (card) {
    var hp = (card.getAttribute('href') || '').split('/products/')[1]; var m = hp ? [0, hp.split(/[?#]/)[0]] : null;
    if (!m || !DATA[m[1]]) return;
    var media = card.querySelector('.acl-card__media');
    if (!media) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'acl-card__qa';
    b.setAttribute('data-acl-qs', m[1]);
    b.innerHTML = '<span>Quick add</span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
    media.appendChild(b);
  });
})();